/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcDtccCnsV1AssetDayState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_DTCC_CNS_V1_ASSET_DAY_STATE_ENTITY_NAME = 'ixc.dtcc.cns.v1.AssetDay';
export const ixcDtccCnsV1AssetDayStateEntity = new schema.Entity<IxcDtccCnsV1AssetDayState>(IXC_DTCC_CNS_V1_ASSET_DAY_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcDtccCnsV1AssetDayState) => `${entity.assetId}-${entity.date}` });

